import React, { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  private handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center gap-3">
          <AlertTriangle className="text-red-500 flex-shrink-0" size={24} />
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-red-800">
              Algo salió mal
            </h3>
            <p className="text-xs text-red-600 truncate">
              {this.state.error?.message || 'Error desconocido'}
            </p>
          </div>
          <button
            onClick={this.handleRetry}
            className="p-2 hover:bg-red-100 rounded-full text-red-600 transition-colors"
            title="Reintentar"
          >
            <RefreshCw size={16} />
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
